import { parseSalespersonHeader, normalizeExcelDate, isIgnoredRow } from "./profitMakerCommon.js";

function isOrderRow(row) {
  const orderNumber = row[0]
  const customerName = row[3]
  const orderDate = row[4]

  return (
    orderNumber &&
    !isNaN(Number(orderNumber)) &&
    typeof customerName === 'string' &&
    customerName.trim().length > 0 &&
    orderDate
  )
}

function parsePercent(value) {
  if (value == null || value === '') return null

  if (typeof value === 'string') {
    return Number(value.replace('%', '')) || null
  }

  return Number(value)
}

export function parseProfitMakerOJ(
  rows,
  sourceFile
) {

  const results = []
  let currentSalesperson = null

  rows.forEach((row, index) => {
    const firstCell = String(row[0] ?? '').trim()

    const sp = parseSalespersonHeader(firstCell)
    if (sp) {
      currentSalesperson = sp
      return
    }

    if (!currentSalesperson) return
    if (isIgnoredRow(row)) return
    if (!isOrderRow(row)) return

    results.push({
      source: 'PROFITMAKER_OJ',
      primary_rep_id: currentSalesperson.id,
      primary_rep_name: currentSalesperson.name,

      order_number: String(row[0]),
      customer_id: row[2] ? String(row[2]) : null,
      customer_name: String(row[3]),

      order_date: normalizeExcelDate(row[4]),
      unit: row[6] ? Number(row[6]) : null,
      status: row[7] ? String(row[7]) : null,
      order_code: row[8] ? Number(row[8]) : null,

      order_amount: Number(row[9] ?? 0),
      order_cost: Number(row[11] ?? 0),
      gp_amount: Number(row[12] ?? 0),
      gp_percent: parsePercent(row[13]),
      commission_amount: Number(row[14] ?? 0),

      affected: row[15] ? String(row[15]) : null,

      source_file: sourceFile,
      raw_row_index: index + 1
    })
  })

  return results
}

export function parseProfitMakerSJ(rows, sourceFile) {
  const results = [];
  let currentSalesperson = null;

  rows.forEach((row, index) => {
    const firstCell = String(row[0] ?? "").trim();

    const sp = parseSalespersonHeader(firstCell);
    if (sp) {
      currentSalesperson = sp;
      return;
    }

    if (!currentSalesperson) return;

    if (isIgnoredRow(row)) return;

    const invoiceNumber = row[0];
    const customerName = row[2];
    const invoiceDate = row[4];

    if (
      !invoiceNumber ||
      isNaN(Number(invoiceNumber)) ||
      !customerName ||
      !invoiceDate
    ) {
      return;
    }

    results.push({
      source: "PROFITMAKER_SJ",

      primary_rep_id: currentSalesperson.id,
      primary_rep_name: currentSalesperson.name,

      invoice_number: String(row[0]),
      customer_id: row[1] ? String(row[1]) : null,
      customer_name: String(row[2]),

      invoice_date: normalizeExcelDate(row[4]),
      unit: row[6] ? Number(row[6]) : null,
      status: row[7] ? String(row[7]) : null,

      sales: Number(row[8] ?? 0),
      order_code: row[9] ? Number(row[9]) : null,
      gl_shipping_insurance: Number(row[10] ?? 0),
      taxes: Number(row[12] ?? 0),
      other: Number(row[13] ?? 0),

      invoice_amount: Number(row[14] ?? 0),
      invoice_cost: Number(row[15] ?? 0),
      gp_percent: parsePercent(row[16]),
      commission_amount: Number(row[17] ?? 0),

      order_number: row[18] ? String(row[18]) : null,

      source_file: sourceFile,
      raw_row_index: index + 1
    });
  });

  return results;
}


